import React from 'react';
import {
  Box, Button, Typography,
} from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

import useStyles from '../styles';
import { EnrollmentFormData } from '../types';
import DynamicForm from './DynamicForm';
import { StepConfig } from '../formConfig';
import { ValidationError } from '../validations';

interface FormContentProps {
  currentStep: number;
  formData: EnrollmentFormData;
  onFormChange: (data: Partial<EnrollmentFormData>) => void;
  onNext: () => void;
  onBack: () => void;
  onSubmit: () => void;
  totalSteps: number;
  validationErrors: ValidationError[];
  enrollmentSteps: StepConfig[];
}

function FormContent({
  currentStep,
  formData,
  onFormChange,
  onNext,
  onBack,
  onSubmit,
  totalSteps,
  validationErrors,
  enrollmentSteps,
}: FormContentProps) {
  const classes = useStyles();

  const currentStepConfig = enrollmentSteps.find(
    (step) => step.stepNumber === currentStep,
  );

  if (!currentStepConfig) return null;

  const handleNextClick = () => {
    if (currentStep === totalSteps) {
      onSubmit();
    } else {
      onNext();
    }
  };

  return (
    <Box className={classes.formContainer}>
      <Box className={classes.formContent}>
        <DynamicForm
          stepConfig={currentStepConfig}
          formData={formData}
          onFormChange={onFormChange}
          validationErrors={validationErrors}
        />
      </Box>
      <Box className={classes.buttonContainer}>
        {currentStep > 1 && (
          <Button
            variant="contained"
            color="primary"
            onClick={onBack}
            startIcon={<ArrowBackIos />}
            className={classes.button}
          >
            <Typography className={classes.buttonText}>
              Anterior
            </Typography>
          </Button>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleNextClick}
          endIcon={<ArrowForwardIos />}
          className={classes.button}
          fullWidth={currentStep === 1}
        >
          <Typography className={classes.buttonText}>
            {currentStep === totalSteps ? 'Finalizar' : 'Siguiente'}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}

export default FormContent;
